module.exports = __webpack_public_path__ + "images/4.1787648603550.jpg";